import React, { useState } from "react";
import Programs from "../components/Programs/Programs";
import Aside from "../modules/SideNav/Aside";

function ProgramsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <Programs handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default ProgramsLayout;
